import SuggestedTags from './SuggestedTags';

export default SuggestedTags;